/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <no-ssr>
    <div class="position-relative">
      <b-form-checkbox
        :id="name"
        :name="name"
        v-model="valueComputed"
        :class="checkboxClass"
        @input="$emit('input', $event)"
        :state="validState"
        :switch="switchVal"
        v-bind="propsList"
        >
        <span class="checkbox-text" :class="[labelClass]" v-html="label" @click="label_click($event)"></span>
      </b-form-checkbox>
      <b-form-invalid-feedback :state="validState">
        <!-- This will only be shown if the preceeding input has an invalid state -->
        <div v-for="(validation, index) in validationsFiltered"
          :key="index">
          {{ validation.text }}
        </div>
      </b-form-invalid-feedback>
    </div>
  </no-ssr>
</template>

<script>
import filter from 'lodash/filter'

export default {
  props: {
    value: {
      type: [Boolean],
      required: true
    },
    name: {
      type: String,
      default: () => ''
    },
    label: {
      type: String,
      default: () => ''
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    validations: {
      type: Array,
      required: false,
      default: () => []
    },
    use_prevent: {
      type: Boolean,
      required: false,
      default: false
    },
    checkboxClass: {
      type: String,
      required: false
    },
    switchVal: {
      type: Boolean,
      required: false,
      default: false
    },
    propsList: {
      type: Object,
      required: false,
      default: () => {}
    },
    labelClass: {
      type: String,
      default: ''
    }
  },
  $_veeValidate: {
    value () {
      // used for validation parents
      return this.value
    },
    name () {
      return this.name
    }
  },
  computed: {
    validationsFiltered () {
      return filter(this.validations, { condition: true })
    },
    valueComputed: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    },
    validState () {
      let state = null
      for (let validation of this.validations) {
        if (validation.condition) {
          state = false
          break
        }
      }
      return state
    }
  },
  methods: {
    label_click (e) {
      if (this.use_prevent) {
        e.preventDefault()
      }
      this.$emit('label-clicked', true)
    }
  }
}
</script>
<style lang="scss" scoped>
  .form-control{
    border: none;
  }
  span.bcm-link {
    cursor: pointer!important;
  }
</style>
